import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import swal from "sweetalert";

export const getAllCourseSubscriptionsApi = createAsyncThunk(
  "subscriptions/course/getAll",
  async (pageNumber) => {
    const tokenData = await JSON.parse(localStorage.getItem("userData")).token;
    const request = await fetch(
      `${process.env.REACT_APP_VERSEL_API}/api/user/subscripers/getAllSubscriptions/course/?page=${pageNumber}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${tokenData}`,
        },
      }
    )
      .then((response) => response.json())
      .then((result) => {
        return result;
      })
      .catch((error) => {
        formatError(error);
        return error;
      });

    return request;
  }
);

function formatError(errorResponse) {
  swal("Oops", `${errorResponse}`, "error");
}

const getAllCourseSubscriptionsSlicer = createSlice({
  name: "getAllCourseSubscriptions",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  extraReducers: (builder) => {
    builder.addCase(getAllCourseSubscriptionsApi.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllCourseSubscriptionsApi.fulfilled, (state, action) => {
      state.loading = false;
      if (action.payload.message === "fetched successfully") {
        state.data = action.payload;
      } else {
        state.error = action.payload.message;
        formatError(state.error);
      }
    });
    builder.addCase(getAllCourseSubscriptionsApi.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
      formatError(state.error);
    });
  },
});

export default getAllCourseSubscriptionsSlicer.reducer;
